export default __webpack_public_path__ + "static/media/patnership.bc72f75c.png";